__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/4f616ee3d73eb73839b06a78c1c16502e0ced5b4/_next/";